<template>
  <div class="receivingAddress">

    <div class="list-con">
      <van-swipe-cell
          v-for="(item, i) in list"
          :key="item.userAddressId"
          :name="item.userAddressId"
          :right-width="65"
          :on-close="onClose"
          :stop-propagation="true"
      >
        <div class="list">
          <div class="left-icon" v-if="item.isShowActive"></div>
          <div class="address-con" @click="addressClick(item)">
            <div class="name">
              <span style="padding-right: 15px;">收货人：{{ item.addresseeName }}</span><span >{{ item.addresseeTel }}</span>
            </div>
            <div class="address">收货地址：{{ item.fullArea + item.detailAddress }}</div>
          </div>
          <div class="edit-icon" @click="goEditAddress(item)"><div class="icon"></div></div>
        </div>
        <template slot="right">
          <!--<van-button square type="primary" text="收藏"/>-->
          <div class="remove-attention">删除<br>地址</div>
        </template>
      </van-swipe-cell>

    </div>
    <div class="no-list" v-if="list.length===0">
      <div class="no-list-icon"></div>
    </div>
    <div class="btn"  @click="goAddAddress">+新增地址</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addressList, deleteAddress } from '@/api/mall/mallLogistics'
export default {
  components: {
  },
  data(){
    return {
      addrId: '',
      list: []
    }
  },
  computed:{
    ...mapGetters([
      'addressList',//用户地址列表
      'addressSelectedId',//用户地址id
    ])
  },
  watch: {
    addressSelectedId: {
      handler(val, oldVal) {

      },
      immediate: true,
    },
    addressList: {
      handler(val, oldVal) {
        this.list = Object.assign([], val)
      },
      immediate: true,
      deep: true
    },
  },
  created(){
    // console.log('this.$route.query.addressSelectedId', this.$route.query.addressSelectedId)
    this.addrId = this.$route.query.addressSelectedId || this.addressSelectedId || '';
    if(this.list.length<1){
      this.$store.dispatch('my/getAddressList', {openid: this.session('userOpenId')})
    }
    if(this.$route.query.addressSelectedId===''||this.$route.query.addressSelectedId){
      document.title = '选择地址'
    }
  },
  methods:{

    goAddAddress(){
      this.$router.push({name: 'editAddress'})
    },
    goEditAddress(item){
      this.$router.push({name: 'editAddress', query: { userAddressId: item.userAddressId } })
    },

    onClose(clickPosition, instance, nameData){
      if(clickPosition==='right'){
        console.log(nameData)
        this.$dialog.confirm({
          title: '提示',
          message: '是否确认删除该地址？',
        }).then(() => {
          // on confirm
          this.deleteAddress(nameData.name)
          instance.close()
        }).catch(() => {
          instance.close()
        });
      }
    },

    // 删除地址
    deleteAddress(userAddressId){
      deleteAddress({userAddressId}).then(res=>{
        if(res.code===200){
          this.$toast('删除成功！')
          this.getAddressList()
        }else {
          this.$toast(res.message)
        }
      })
    },

    //点击地址时
    addressClick(item){
      if(this.$route.query.addressSelectedId==='' || this.$route.query.addressSelectedId){ //不能为null 或者undefined
        console.log(item.userAddressId)
        this.$store.commit('my/change_addressSelectedId', item.userAddressId)
        this.$router.go(-1)
      }
    },

  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.receivingAddress{
  position: relative;z-index: 0;width: 100%;height: 100%;
  .list-con{
    position: absolute;top: 0;left: 0;right: 0;bottom: 67px;overflow-y: auto;
    .list{
      display: flex;height: 72px;
      border-bottom: 1px solid #efefef;
      padding: 10px 0;
      font-size: 14px;
      .left-icon{
        display: inline-flex;width: 27px;height: 100%;
        background: url("@{url}Fpzfmrg39Mb9kBy0J3yOAGNkxlQU") no-repeat 100% 50%;background-size: 15px 15px;
      }
      .address-con{
        flex: 1;color: #2b2b2b;padding-left: 12px;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-around;
        .name{
          font-size: 14px;
          font-weight: bold;
        }
        .address{
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .edit-icon{
        display: inline-flex;width: 39px;height: 100%;
        justify-content: center;align-items: center;
        .icon{
          display: inline-flex;width: 15px;height: 15px;margin: 0 12px;
          background: url("@{url}Fgcw7b_b8bo6FqJkYLHvVoJ1R4Id") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }

    .remove-attention{
      display: inline-flex;justify-content: center;align-items: center;width: 65px;
      height: 100%;background: #aaa;font-size: 16px;color: #fcfcfc;
    }
  }

  .no-list{
    .no-list-icon{
      width: 100%;height: 234px;
      background: url("@{url}FsTl7J8g5eL1rvPa17bzGOJckgmj") no-repeat 50% 100%;
      background-size: 193px 151px;
    }
  }
  .btn{
    position: absolute;
    left: 12px;bottom: 15px;
    width: 352px;height: 40px;border-radius: 20px;
    display: flex;justify-content: center;align-items: center;
    background-color: #1585f3;color: #fff;font-size: 16px;
  }
}
</style>